<template>
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        {{ title }}
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs6>
                <TitleTextField
                  v-model="entity.number"
                  :required="true"
                  :rules="[
                    v => !!v || 'Наименование обязательно к заполнению',
                    v =>
                      v.length >= 3 ||
                      'Наименование должно содержать не менее 3-х символов'
                  ]"
                  label="Номер*"
                  class="mx-2"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs6>
                <TitleTextField
                  v-model="entity.trailerNumber"
                  label="Номер прицепа*"
                  class="mx-2"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <app-reference
                  v-model="entity.carrier"
                  class="mx-2 mb-3"
                  label="Перевозчик*"
                  :rules="[v => !!v || 'Перевозчик обязателен к заполнению']"
                  resource="carriers"
                  component-name="Carrier"
                  :data-restored="entityRestored"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs6>
                <app-reference
                  v-model="entity.type"
                  class="mx-2 mb-3"
                  label="Тип подвижного состава*"
                  :rules="[v => !!v || 'Тип подвижного состава обязателен к заполнению']"
                  resource="rolling-stock-types"
                  component-name="RollingStockType"
                  :data-restored="entityRestored"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.lengthMain"
                  class="mx-2 mb-3"
                  :required="true"
                  :rules="[v => !!v || 'Длина 1 обязательна к заполнению']"
                  label="Длина тягача*"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.widthMain"
                  class="mx-2 mb-3"
                  :required="true"
                  :rules="[v => !!v || 'Ширина 1 обязательна к заполнению']"
                  label="Ширина тягача*"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.heightMain"
                  class="mx-2 mb-3"
                  :required="true"
                  :rules="[v => !!v || 'Высота 1 обязательна к заполнению']"
                  label="Высота тягача*"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="volumeMain"
                  class="mx-2 mb-3"
                  label="Объем тягача"
                  disabled
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.lengthAdditional"
                  class="mx-2 mb-3"
                  label="Длина прицепа"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.widthAdditional"
                  class="mx-2 mb-3"
                  label="Ширина прицепа"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="entity.heightAdditional"
                  class="mx-2 mb-3"
                  label="Высота прицепа"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs3>
                <DecimalEditor
                  v-model="volumeAdditional"
                  class="mx-2 mb-3"
                  label="Объем прицепа"
                  disabled
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <DecimalEditor
                  v-model="volume"
                  class="mx-2 mb-3"
                  label="Общий объем"
                  disabled
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                />
              </v-flex>
              <v-flex xs6>
                <DecimalEditor
                  v-model="entity.carryingCapacity"
                  class="mx-2 mb-3"
                  label="Грузоподъемность"
                  :scale="2"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-btn
            small
            color="primary"
            :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
            @click="submit(false)"
          >
            Сохранить
          </v-btn>
          <v-btn
            v-if="!isModal"
            small
            color="primary"
            :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
            @click="saveAndClose"
          >
            Сохранить и закрыть
          </v-btn>
          <v-btn
            small
            @click="cancel"
          >
            Отмена
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="entity.id!==0 || entity.id!==0 && isConfirmed === true"
            small
            :color="entity.isRemoved ? 'success' :'error'"
            @click="changeRemovedState"
          >
            {{ entity.isRemoved ? "Восстановить" : "Удалить" }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import * as vehiclesApi from "../../backend/vehiclesApi.js";

export default {
  mixins: [mixin],
  props: ["id", "isEventCancel", "isEditInModal"],
  data() {
    return {
      entity: {
        id: 0,
        number: "",
        trailerNumber: null,
        carrier: null,
        type: null,
        lengthMain: 0,
        lengthAdditional: 0,
        widthMain: 0,
        widthAdditional: 0,
        heightMain: 0,
        heightAdditional: 0,
        carryingCapacity: 0,
      },
      entityRestored: false,
      resource: "vehicles",
      isValid: false,
      isChanged: false,
      loading: false,
    };
  },
  computed: {
    title() {
      return this.isNew ? "Создание машины" : "Редактирование машины";
    },
    isNew() {
      return !this.id || this.id === "0";
    },
    isModal() {
      if (this.isEditInModal) {
        return true;
      }
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    volumeMain() {
      return (
        this.entity.lengthMain * this.entity.widthMain * this.entity.heightMain
      );
    },
    volumeAdditional() {
      return (
        this.entity.lengthAdditional *
        this.entity.widthAdditional *
        this.entity.heightAdditional
      );
    },
    volume() {
      return this.volumeMain + this.volumeAdditional;
    },
  },
  created() {
    if (!this.isNew) {
      this.getData();
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await vehiclesApi.getVehicle(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    cancel() {
      if (this.isModal && !this.isEditInModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      if (!this.isEditInModal) {
        this.$router.go(-1);
      }
      this.$emit("cancel");
    },
    async submit(closeAfterSubmit) {
      const entity = {
        id: this.entity.id,
        number: this.entity.number,
        trailerNumber: this.entity.trailerNumber,
        carrierId: this.entity.carrier.id,
        typeId: this.entity.type.id,
        lengthMain: this.entity.lengthMain,
        lengthAdditional: this.entity.lengthAdditional,
        widthMain: this.entity.widthMain,
        widthAdditional: this.entity.widthAdditional,
        heightMain: this.entity.heightMain,
        heightAdditional: this.entity.heightAdditional,
        carryingCapacity: this.entity.carryingCapacity,
      };

      if (this.entity.id && this.entity.id > 0) {
        this.loading = true;
        await vehiclesApi.updateVehicle(this.resource, this.entity.id, entity);
        this.showInfo("Машина изменена");
        this.isChanged = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.$emit("save");
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        }
        this.loading = false;
      } else {
        this.loading = true;
        const res = await vehiclesApi.createVehicle(this.resource, entity);
        this.showInfo("Машина добавлена");
        this.isChanged = false;
        this.entity.id = res.data;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
          this.$router.replace(`/${this.resource}/${res.data}`);
        }
        this.loading = false;
      }
    },
    async saveAndClose() {
      await this.submit(true);
    },
    async changeRemovedState() {
      await vehiclesApi.changeRemovedState(this.resource, this.entity);
      this.entity.isRemoved = !this.entity.isRemoved;
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
